import colors from './colors';
import { fonts } from './fonts';

const foundations = {
  colors,
  fonts,
};

export default foundations;
